import React from 'react';
import Print58 from "./print58";
import ReactToPrint from "react-to-print";

let componentRef = React.createRef();
const PrintA4 = ({...props}) => {
    const {list, t} = props;

    return (
        <div>
            <ReactToPrint
                trigger={() => <button id="printa4"
                                       className="btn btn-outline-success">{t("labels:print_all")} (A4)</button>}
                content={() => componentRef}
            />
            <div style={{display: "none"}}>
                <div className="row A4" ref={el => (componentRef = el)}>
                    {
                        list.map((result, i) => {
                            return <Print58 isShow key={i} className="mr-3 print58" object={result}/>
                        })
                    }
                </div>
            </div>
        </div>

    )
};

export default PrintA4;
